var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3957 13.6032L14.6332 9.36572M19.7147 3.36621L2.23971 8.28808C2.09095 8.32875 1.95835 8.41429 1.85996 8.53304C1.76157 8.6518 1.70219 8.798 1.68989 8.95172C1.67759 9.10545 1.71298 9.25922 1.79124 9.39211C1.86949 9.525 1.98681 9.63053 2.12721 9.69433L10.1522 13.4912C10.3094 13.564 10.4357 13.6903 10.5085 13.8475L14.3053 21.8725C14.3691 22.0129 14.4747 22.1302 14.6076 22.2084C14.7404 22.2867 14.8942 22.3221 15.0479 22.3098C15.2017 22.2975 15.3479 22.2381 15.4666 22.1397C15.5854 22.0413 15.6709 21.9087 15.7116 21.76L20.6335 4.28496C20.6708 4.15743 20.6731 4.02223 20.6401 3.89351C20.6072 3.76479 20.5403 3.6473 20.4463 3.55335C20.3524 3.4594 20.2349 3.39245 20.1062 3.35953C19.9774 3.3266 19.8422 3.32891 19.7147 3.36621Z",
    stroke: "#1F1D1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/send-icon.12c388ba466aea41a58e06a80b8fad25.svg";
export { ForwardRef as ReactComponent };